/**
 * Builds a URL for the login entrypoint.
 * Redirects to the identity provider login page regardless of current authentication status.
 *
 * @param options.returnTo - URL to redirect to after successful login. Defaults to '/dashboard'.
 */
export function buildLoginUrl(options) {
    const params = new URLSearchParams();
    if (options?.returnTo) {
        params.set('returnTo', options.returnTo);
    }
    const search = params.toString();
    return search ? `/login?${search}` : '/login';
}
/**
 * Builds a URL for the registration entrypoint.
 * Redirects to the identity provider registration page regardless of current authentication status.
 *
 * @param options.returnTo - URL to redirect to after successful registration. Defaults to '/dashboard'.
 */
export function buildRegisterUrl(options) {
    const params = new URLSearchParams();
    if (options?.returnTo) {
        params.set('returnTo', options.returnTo);
    }
    const search = params.toString();
    return search ? `/register?${search}` : '/register';
}
